import http from "../httpService";
import { apiUrl } from "../../config.json";
import { getAuthToken } from "../Authentication/AuthService";

const headers = {
  "x-access-token": getAuthToken(),
};

export const getAllCurriculum = () => {
  return http.get(apiUrl + "/curriculum/getAllCurriculum", {
    headers: headers,
  });
};
export const getUpdateCurriculum = (payload) => {
  return http.post(apiUrl + "/user/updateUserCur",payload, {
    headers: headers,
  });
};

export const CopyCurriculumm = (id) => {
  return http.post(apiUrl + "/curriculum/copycurriculum/"+id, {
    headers: headers,
  });
};

export const CopyCurrSubCourseQuestion = (id) => {
  return http.post(apiUrl + "/curriculum/copycurriculumtest/"+id, {
    headers: headers,
  });
};

export function saveCurriculum(payload, curriculumId) {
  if (!curriculumId) {
    //Add Curriculum
    return http.post(apiUrl + "/curriculum/createCurriculum", payload, {
      headers: headers,
    });
  } else {
    //Edit Curriculum
    // const editpayload = {
    //   condition: { _id: curriculumId },
    //   updateData: payload,
    // };
    delete payload._id;

    return http.post(apiUrl + "/curriculum/updateCurriculum/"+ curriculumId, payload, {
      headers: headers,
    });
  }
}

export const getCurriculum = (curriculumId) => {
  return http.post(apiUrl + "/curriculum/getCurriculum", curriculumId, {
    headers: headers,
  });
};
export const deleteCurriculum = (payload) => {
  return http.post(apiUrl + "/curriculum/removeCurriculum", payload, {
    headers: headers,
  });
};
